import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';

// Service Pages
import WebDevelopment from './pages/services/WebDevelopment';
import UIUXDesign from './pages/services/UIUXDesign';
import Blockchain from './pages/services/Blockchain';
import ECommerce from './pages/services/ECommerce';
import MobileApp from './pages/services/MobileApp';
import CloudSolutions from './pages/services/CloudSolutions';
import DigitalMarketing from './pages/services/DigitalMarketing';
import CreativeCopywriting from './pages/services/CreativeCopywriting';
import AIAndML from './pages/services/AIAndML';
import DataAnalytics from './pages/services/DataAnalytics';
import WebDevelopmentTrends2025 from './pages/blog/WebDevelopmentTrends2025';
import AIBusinessApplications from './pages/blog/AIBusinessApplications';
import UXDesignPrinciples from './pages/blog/UXDesignPrinciples';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
            
            {/* Service Pages */}
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
            <Route path="/services/blockchain" element={<Blockchain />} />
            <Route path="/services/e-commerce" element={<ECommerce />} />
            <Route path="/services/mobile-app" element={<MobileApp />} />
          <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
          <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/services/creative-copywriting" element={<CreativeCopywriting />} />
          <Route path="/services/ai-ml" element={<AIAndML />} />
          <Route path="/services/data-analytics" element={<DataAnalytics />} />
          
          {/* Blog Posts */}
          <Route path="/blog/web-development-trends-2025" element={<WebDevelopmentTrends2025 />} />
          <Route path="/blog/ai-business-applications" element={<AIBusinessApplications />} />
          <Route path="/blog/ux-design-principles" element={<UXDesignPrinciples />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
